<template>
  <page heading="Search Ponies">
    <h3>Browse by Characteristic</h3>
    <ul class="pony-search-list">
      <li>
        <router-link to="/brands">Brand</router-link>
      </li>
      <li>
        <router-link to="/body-colors">Body Color</router-link>
      </li>
      <li>
        <router-link to="/characters">Character</router-link>
      </li>
      <li>
        <router-link to="/countries">Sold In</router-link>
      </li>
      <li>
        <router-link to="/molds">Species</router-link>
      </li>
      <li>
        <router-link to="/hair-colors">Hair Color</router-link>
      </li>
      <li>
        <router-link to="/list/age">Age</router-link>
      </li>
      <li>
        <router-link to="/list/gender">Gender</router-link>
      </li>
      <li>
        <router-link to="/list/symbol-type">Symbol Type</router-link>
      </li>
      <li>
        <router-link to="/list/eye-type">Eye Type</router-link>
      </li>
      <li>
        <router-link to="/origins">Origin</router-link>
      </li>
      <li>
        <router-link to="/manufacturers">Manufacturer</router-link>
      </li>
      <li>
        <router-link to="/releases">Release</router-link>
      </li>
      <li>
        <router-link to="/poses">Pose</router-link>
      </li>
      <li>
        <router-link to="/themes">Theme</router-link>
      </li>
      <li>
        <router-link to="/years">Year Made</router-link>
      </li>
      <li>
        <router-link to="/generations">Generation</router-link>
      </li>
      <li>
        <router-link to="/accessories">Accessories</router-link>
      </li>
      <li>
        <router-link to="/groupings">Groupings</router-link>
      </li>
      <li>
        <router-link to="/ponies">Ponies</router-link>
      </li>
    </ul>
    <h3>Filter Ponies</h3>
  </page>
</template>

<script>
import Page from '../../layouts/Page/Page';

export default {
  name: 'PonySearch',
  components: {
    Page
  }
};
</script>
